import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'acl-installation-ctd-limit',
  standalone: false,
  templateUrl: './installation-ctd-limit.component.html',
  styleUrl: './installation-ctd-limit.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InstallationCtdLimitComponent {

}
